import { useRouter } from "vue-router"
import { useShopListStore } from "~/stores/shopListStore"

export function useHomeSearchFilter() {
    const router = useRouter()
    const onQueryChange = ({
        params,
        route = undefined,
        onSuccess = () => {},
        onError = (e: any) => {},
        onFinish = () => {},
    }: {
        params: any
        route?: string
        onSuccess?: () => void
        onError?: (e: any) => void
        onFinish?: () => void
    }) => {
        const shopListStore = useShopListStore()
        const urlRedirect = shopListStore.currentShop ? `/store/${shopListStore.currentShop?.slug}` : '/store'

        router
            .push({
                path: route ?? urlRedirect,
                query: params,
            })
            .then(() => {
                onSuccess()
            })
            .catch((e) => {
                console.log(e)
                onError(e)
            })
            .finally(() => {
                onFinish()
            })
    }

    return {
        onQueryChange,
    }
}
